<div class="success-container">
  <div class="success-content">
    <img class="checkmark-circle" src="../../../assets/Complete sign.svg" alt="Success" />
    <p class="success-message">Agro Dealer has been added successfully</p>
  </div>

  <div class="button-wrapper">
    <button mat-raised-button color="primary" class="main-screen-button" (click)="goToMainScreen()">
      Go back to main screen
    </button>
  </div>
</div>